<template>
    <b-sidebar
            backdrop
            id="sidebasket"
            no-header
            right
            sidebar-class="sidebasket"
            title="Basket">
        <template v-slot:default="{ hide }">
            <h4 id="sidebar-no-header-title" class="title">
                Basket
                <b-button size="sm" @click="hide" class="close">×</b-button>
            </h4>

            <!-- Basket Items -->
            <template v-if="deviceCount > 0">
                <!-- Items -->
                <basket-item
                        v-for="(device, key) in devices"
                        :key="key"
                        :device-data="device"
                        :device-key="key"
                        hideControls hideImage>
                </basket-item>

                <!-- Total Cost -->
                <table class="price-table grand-total" v-if="!inWarrantyStatus">
                    <template v-if="discountCodeInCart">
                        <tr>
                            <td>Subtotal:</td>
                            <td><span v-html='currencySymbol'></span>{{ fullPrice }}</td>
                        </tr>
                        <tr>
                            <td>Promo:</td>
                            <td>-<span v-html='currencySymbol'></span>{{ discountTotal }}</td>
                        </tr>
                    </template>
                    <tr class="total-cost">
                        <td>Total:</td>
                        <td><span v-html='currencySymbol'></span>{{ cartTotal }}</td>
                    </tr>
                </table>

                <div class="row">
                    <div class="col-12">
                        <button @click="goToBasket" v-b-toggle.sidebasket class="btn btn-block btn-lg continue-btn mb-4" :disabled="disableBasketButton">Go to basket</button>
                    </div>
                </div>

                <div class="col-12 text-center text-sm">
                    <p>
                        By completing your order, you agree to our <router-link :to="{name: 'Terms'}" target="_blank">terms and conditions</router-link> and <router-link :to="{name: 'Privacy'}" target="_blank">privacy policy</router-link>.
                    </p>
                    <p class="mt-4">
                        <a href="#" @click.prevent @click="startNewBooking">Clear booking</a><br/>
                        <a href="#" v-if="storeCode" @click="resetStoreSettings">Clear store</a>
                    </p>
                </div>
                <div class="protection-icons">
                    <div class="col-4">
                        <img srcset="https://res.cloudinary.com/wefix/image/upload/v1564755328/booking/norton_logo.png 1x, https://res.cloudinary.com/wefix/image/upload/v1564755328/booking/norton_logo_2x.png 2x"
                             src="https://res.cloudinary.com/wefix/image/upload/v1564755328/booking/norton_logo.png"
                             alt="Norton Secured"
                             class="protection-logo" />
                    </div>
                    <div class="col-4">
                        <img srcset="https://res.cloudinary.com/wefix/image/upload/v1564755425/booking/etrust_logo.png 1x, https://res.cloudinary.com/wefix/image/upload/v1564755425/booking/etrust_logo_2x.png 2x"
                             src="https://res.cloudinary.com/wefix/image/upload/v1564755425/booking/etrust_logo.png"
                             alt="TRUSTe Verified"
                             class="protection-logo" />
                    </div>
                    <div class="col-4">
                        <img srcset="https://res.cloudinary.com/wefix/image/upload/v1564755484/booking/mcafee_logo.png 1x, https://res.cloudinary.com/wefix/image/upload/v1564755484/booking/mcafee_logo_2x.png 2x"
                             src="https://res.cloudinary.com/wefix/image/upload/v1564755484/booking/mcafee_logo.png"
                             alt="McAfee Secure"
                             class="protection-logo" />
                    </div>
                </div>

            </template>

            <!-- Empty basket -->
            <div class="py-2 text-center" v-if="deviceCount === 0">
                <icon-shopping-cart class="icon-all-text-colour icon-chunky mb-2 mx-auto" size="lg"></icon-shopping-cart>
                <strong>There are no items in the basket</strong>
                <div @click="addDeviceLink" class="btn btn-block btn-lg continue-btn mb-4 mt-4">Add device</div>
            </div>

        </template>
    </b-sidebar>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        name: "SideBasket",

        computed: {
            ...mapGetters([
                "booking",
                "carrierDetails",
                "carrier",
                "cartTotal",
                "devices",
                "discountCodeInCart",
                "discountTotal",
                "fullPrice",
                "requiresStore",
                'disableBasketButtonOnConfirmDamagePage',
                'currencySymbol',
                'storeCode',
                'onlyOfferSamsung'
            ]),

            /** Total number of devices in the cart */
            deviceCount() {
                if (!this.devices) return 0;
                return Object.keys(this.devices).length;
            },

            noProblemsSelected() {
                for (let key in this.devices) {
                    if (!Object.prototype.hasOwnProperty.call(this.devices, key)) continue;

                    if (this.devices[key].problems.length === 0) return true;
                }
                return false;
            },

            disableBasketButton() {
                if(this.$route.name !== 'confirmDamage') {
                    return this.noProblemsSelected;
                }

                return this.disableBasketButtonOnConfirmDamagePage;
            }
        },

        methods: {
            ...mapActions([
                "clearBooking",
                'clearDevice',
                "inWarrantyStatus",
                'loadTypes',
                "resetStoreSettings",
                'selectMake'
            ]),

            addDeviceLink() {
                if (this.onlyOfferSamsung) {
                    this.selectMake({
                        id: 2
                    }).then(() => {
                        this.loadTypes();
                        this.$router.push({name: 'deviceType'});
                    })
                    return
                }

                return this.$router.push({name: 'deviceMake'})
            },

            goToBasket() {
                this.$router.push({name: 'basket'})
            },

            startNewBooking() {
                this.clearBooking().then(() => {
                    this.$router.push({name: 'booking'})
                });
            }
        }
    }
</script>

<style scoped>

</style>